module.exports = __webpack_public_path__ + "media/images/logo-bleu-702729b170b316ab442ab69075c70985.svg";